// extracted by css-extract-rspack-plugin
export default {"root":"Notification-module__root___YltE0"};